import React, { useEffect, useState } from 'react';

/**
 * Type-phone confirm before hard-deleting a passenger or captain.
 */
export default function DeleteAccountModal({
  open,
  role, // 'passenger' | 'driver'
  account, // { id, name, phone }
  busy,
  onClose,
  onConfirm,
}) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (open) setTyped('');
  }, [open, account?.id]);

  if (!open || !account) return null;

  const expect = String(account.phone || '').replace(/\D/g, '').slice(-10);
  const label = role === 'driver' ? 'captain' : 'passenger';
  const match = typed.replace(/\D/g, '').slice(-10) === expect && expect.length === 10;

  return (
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-account-title"
      onClick={onClose}
    >
      <div className="modal-sheet" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div className="card-title" id="delete-account-title" style={{ margin: 0, color: 'var(--red)' }}>
            Delete {label}
          </div>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose} disabled={busy}>✕</button>
        </div>

        <p style={{ margin: '0 0 12px', lineHeight: 1.45 }}>
          This permanently removes <strong>{account.name || 'this account'}</strong>
          {expect ? <> (<span className="mono">+91 {expect}</span>)</> : null} from records and Firebase Auth.
          They cannot sign in with this phone again.
        </p>
        <p className="muted" style={{ fontSize: 13, margin: '0 0 14px', lineHeight: 1.4 }}>
          Ride history is kept. Any active trip for this {label} will be cancelled.
        </p>

        <label className="field-label">Type phone number to confirm</label>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span className="muted">+91</span>
          <input
            type="tel"
            inputMode="numeric"
            maxLength={10}
            autoFocus
            placeholder={expect || '10-digit mobile'}
            value={typed}
            disabled={busy}
            onChange={(e) => setTyped(e.target.value.replace(/\D/g, '').slice(0, 10))}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 18 }}>
          <button type="button" className="btn btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button
            type="button"
            className="btn btn-red"
            disabled={!match || busy}
            onClick={() => onConfirm(typed.replace(/\D/g, '').slice(-10))}
          >
            {busy ? 'Deleting…' : 'Delete forever'}
          </button>
        </div>
      </div>
    </div>
  );
}
